app.service("select", () => {
	let $currentOpenedSelect, $optionsWrapper, $options, $input, $message, $autocomplete;

	const openSelect = ($select) => {
		$currentOpenedSelect = $select;
		$optionsWrapper = $currentOpenedSelect.querySelector(".js-customic-select-options");
		$options = $currentOpenedSelect.querySelectorAll(".js-customic-select-option");
		$input = $currentOpenedSelect.querySelector(".js-customic-select-input");
		$message = $currentOpenedSelect.querySelector(".js-customic-select-message");
		$autocomplete = $currentOpenedSelect.querySelector(".js-customic-select-autocomplete");
		$currentOpenedSelect.classList.add("show-options");
		setPositionToOptionsWrapper();
		if ($autocomplete) {
			if ($input.value === '') {
				$autocomplete.value = '';
				filterSelect($autocomplete.value);
			} else {
				filterSelect($autocomplete.value);
			}
		}
		/*
		$autocomplete.addEventListener("keyup", (event) => {
			if(event.keyCode == 40){
				selectDownOption();
			} else if(event.keyCode == 38){
				selectUpOption();
			} else if(event.keyCode === 13){
				selectEnterOption();
			} else if(event.keyCode === 27){
				$autocomplete.blur();
				selectEscOption();
			}
		});
		*/

	};
	/*
	const selectDownOption = () => {
		console.log('down')
	}

	const selectUpOption = () => {
		console.log('up')
	}

	const selectEnterOption = () => {
		console.log('enter')
	}

	const selectEscOption = () => {
		console.log('esc');
		closeSelect();
	}
	*/
	const closeSelect = () => {
		$currentOpenedSelect.classList.remove("show-options");
		if ($autocomplete) {
			let value = '';
			$options.forEach(($option) => {
				if ($option.dataset.selected === 'true') {
					value = $option.innerText.trim();
				}
			});
			$autocomplete.value = value;
		}
		resetElements();
	};

	const resetElements = () => {
		$currentOpenedSelect = null;
		$optionsWrapper = null;
		$options = null;
		$input = null;
		$message = null;
		$autocomplete = null;
	};

	const setOptionToSelected = (value) => {
		$options.forEach(($option) => {
			$option.dataset.selected = $option.dataset.value === value;
		});
	};

	const setPositionToOptionsWrapper = () => {
		const selectTopPosition = $currentOpenedSelect.getBoundingClientRect().top;
		let optionsWrapperHeight = $optionsWrapper.getBoundingClientRect().height;

		if (window.innerHeight < Number(getComputedStyle($optionsWrapper).maxHeight.replace(/\D/g, ""))) {
			$optionsWrapper.style.maxHeight = `${window.innerHeight}px`;
			optionsWrapperHeight = window.innerHeight;
		}

		if (!$autocomplete && window.innerHeight - selectTopPosition < optionsWrapperHeight) {
			$optionsWrapper.style.top = `${window.innerHeight - selectTopPosition - optionsWrapperHeight}px`;
		} else {
			$($optionsWrapper).removeAttr('style');
		}
	};

	const setSelectedOption = ($option) => {
		const value = $option.dataset.value;
		if (!$option.dataset.hasOwnAction && $input.value !== value) {
			$input.value = value;
			if ($autocomplete) {
				$autocomplete.value = $option.innerText;
				filterSelect($option.innerText);
			} else {
				$message.textContent = $option.innerText;
			}

			setOptionToSelected(value);

			const event = new Event("change");
			$input.dispatchEvent(event);

			closeSelect();
		}
	};

	const setElements = () => {
		$body = document.querySelector("body");
		resetElements();
	};

	const filterSelect = (value) => {
		$currentOpenedSelect.classList.add("show-options");
		const regex = new RegExp(value, "i");
		let count = 0;
		$options.forEach(($option) => {
			const isMatch = ('' + $option.innerText).match(regex) ? true : false;
			if (value.length && !isMatch) {
				$option.classList.add("customic-select-option-hidden");
			} else {
				count++;
				$option.classList.remove("customic-select-option-hidden");
				if (value.length) {
					let label = $option.innerText.replace(new RegExp('(?![^&;]+;)(?!<[^<>]*)(' + value + ')(?![^<>]*>)(?![^&;]+;)', 'gi'), '<strong>$1</strong>');
					$option.innerHTML = label;
				} else {
					$option.innerText = $option.innerText;
				}
			}
		});
		if (count === 0) {
			$optionsWrapper.classList.add('empty');
		} else {
			$optionsWrapper.classList.remove('empty');
		}

	}

	const setEvents = () => {
		$body.addEventListener("focusin", (event) => {
			const $autocomplete = event.target.closest(".js-customic-select-autocomplete");
			if ($autocomplete) {
				$autocomplete.select();
			}
		});

		$body.addEventListener("click", (event) => {
			const $select = event.target.closest(".js-customic-select-row");
			const $option = event.target.closest(".js-customic-select-option");
			const $autocomplete = event.target.closest(".js-customic-select-autocomplete");
			if ($currentOpenedSelect || $select) {
				event.preventDefault();
			}
			if ($autocomplete) {
				openSelect($select);
				return;
			}
			if ($currentOpenedSelect && $option) {
				setSelectedOption($option);
			} else if (!$currentOpenedSelect && $select) {
				openSelect($select);
			} else if ($currentOpenedSelect) {
				closeSelect();
			}
		});
		$body.addEventListener("input", (event) => {
			if ($autocomplete) {
				const value = $autocomplete.value;
				filterSelect(value);
			} else if (event.target.nodeName === 'INPUT' && event.target.className.indexOf('customic-select-message') > -1) {	//sytuacja kiedy wejdziemy tabem	
				const $select = event.target.closest(".js-customic-select-row");
				openSelect($select);
				const value = $autocomplete.value;
				filterSelect(value);
			}
		});
		$body.addEventListener("keyup", (event) => {
			if ($currentOpenedSelect && event.keyCode === 27){
				closeSelect();
			}
			if ($currentOpenedSelect && !$(event.target).closest('.js-customic-select').length){
				closeSelect();
			}
		});
	};

	const init = () => {
		setElements();
		setEvents();
	};

	function setValue({ $input, value, label }) {

		let $message = $input.parent().find(".js-customic-select-message");
		let $options = $input.parent().find('.js-customic-select-option');
		$options.removeAttr('data-selected');
		let $selectedOption = $options.filter(function () {
			return String($(this).data('value')) === value;
		});
		if ($selectedOption.length === 0) {
			throw new Error(`Option with value "${value}" not found.`);
		}
		$selectedOption.get(0).dataset.selected = true;
		$input.val(value);
		$message.text(label || $selectedOption.text().trim());

		let $autocomplete = $input.parent().find('.js-customic-select-autocomplete');
		if ($autocomplete.length) {
			$autocomplete.val($selectedOption.text().trim());
		}
	}

	function clear($input) {
		if (!$input.length) {
			return;
		}
		setValue({$input, value: ""});
		let $autocomplete = $input.parent().find('.js-customic-select-autocomplete');
		if ($autocomplete.length) {
			let $options = $input.parent().find('.js-customic-select-option');
			let $selectedOption = $options.filter(function () {
				return $(this).data('value') === "";
			});
			$autocomplete.val($selectedOption.text().trim());
			$options.removeClass('customic-select-option-hidden');
			$options.removeAttr('data-selected');
			$options.each(function() {
				const cleanText = $(this).text();
				$(this).text(cleanText);
			});
			$selectedOption.get(0).dataset.selected = true;
		}
	}

	function toggleOptionsVisibility($input, state, showSelector, hideSelector) {

		let $options = $input.parent().find('.js-customic-select-option');

		if (state) {
			$options
				.addClass('customic-select-option-hidden')
				.filter(showSelector)
				.removeClass('customic-select-option-hidden');
		} else {
			$options
				.removeClass('customic-select-option-hidden')
				.filter(hideSelector)
				.addClass('customic-select-option-hidden');
		}
	}

	function showOptions($input, showSelector) {

		toggleOptionsVisibility($input, true, showSelector);
	}

	function hideOptions($input, hideSelector) {

		toggleOptionsVisibility($input, false, null, hideSelector);
	}

	/**
	 * Ustawia aktywność selecta (wyszarzony lub nie).
	 * Nie ustawia atrybutu "disabled" na elemencie input,
	 * pole nadal będzie wysyłane w formularzu
	 */
	function toggleActive($input, isActive) {

		$input.closest('.row-select').toggleClass('row-select-disabled', !isActive);
	}

	return {
		init,
		resetElements,
		setValue,
		showOptions,
		hideOptions,
		toggleActive,
		clear
	};
});
